import UserModel from 'src/models/user';
import { Users } from 'src/fixtures/users';

export const User: UserModel = Users[0];
